import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CreateDocument } from "@/04-features/create-document-popup";
import { useState } from "react";
import { useNavigate } from "react-router";
import styles from "./index.module.css";
export const CreateDocumentButton = ({ parentId = null, onProcessFinished = () => { } }) => {
    const [isShown, setShown] = useState(false);
    const navigate = useNavigate();
    return (_jsxs(_Fragment, { children: [_jsxs("button", Object.assign({ className: styles.optionName, type: "button", onClick: () => setShown(true) }, { children: [_jsx("span", { children: "[doc]" }), _jsx("span", { children: "document" })] })), _jsx(CreateDocument, { isOpen: isShown, parentId: parentId, onClose: () => { setShown(false); onProcessFinished(); }, onSuccess: (documentId) => { setShown(false); navigate(`/${documentId}`); } })] }));
};
